/**
 * Класс обертка отвечает за добавлять/удалять класса {@link switchedClass} у элемента {@link element}
 */
import Element from './Element'

export default class ClassSwitcherElement extends Element {
   #switchedClass = ''

   /**
    * @param element       - элемент видимость которого нужно переключать
    * @param switchedClass - имя класса который нужно добавлять/удалять
    */
   constructor(element, switchedClass) {
      super(element)
      this.#switchedClass = switchedClass
   }

   #hasClass = () => this.getElement().classList.contains(this.#switchedClass)

   addClass = () => !this.#hasClass() && this.getElement().classList.add(this.#switchedClass)

   removeClass = () => this.#hasClass() && this.getElement().classList.remove(this.#switchedClass)

   switch = () => this.getElement().classList.toggle(this.#switchedClass)
}